const CMS_IMAGE_BUCKET_URL = /https?:\/\/storage\.googleapis\.com\/drupal-images-[^/]+\//g;

/**
 * Rewrites every CMS image bucket URL in a string (an image object's `url`, or `<img>` tags
 * editors paste into rich-text HTML fields such as field_html_editor) to the same-origin proxy (see packages/config/src/nextjs-config.ts's rewrites and
 * config.assets.cmsImage.uriTransformEndpoint) so the bucket/tenant naming never reaches the browser.
 */
export const rewriteCmsImageUrls = (html: string): string =>
  html.replace(CMS_IMAGE_BUCKET_URL, '/cms-images/');
